<template>
    <basic-container>
        <div class="tar mb20">
            <el-button size="mini" type="primary" @click="goBackHandle">返回</el-button>
            <el-button size="mini" type="primary" @click="orderDetailVisible = true">打印</el-button>
        </div>
        <div style="padding:0 30px;" class="pdf-wrapper" v-if="obj.id">
            <avue-form :option="option" v-model="obj">
                <template slot="tb">
                    <div class="two-line">
                        <div class="line df">
                            <div class="t-label">填表社工</div>
                            <div class="t-content">{{obj.fillName}}</div>
                        </div>
                        <div class="line df">
                            <div class="t-label">填表日期</div>
                            <div class="t-content">{{obj.fillDay}}</div>
                        </div>
                    </div>
                </template>
                <template slot="residenceAddress">
                    <div class="t-content">{{obj.basisArchivePersonalData.residenceProvince}}{{obj.basisArchivePersonalData.residenceCity}}{{obj.basisArchivePersonalData.residenceDistrict}}{{obj.basisArchivePersonalData.residenceAddress}}</div>
                </template>
                <template slot="actualResidentialAddress">
                    <div class="t-content">{{obj.basisArchivePersonalData.actualResidenceProvince}}{{obj.basisArchivePersonalData.actualResidenceCity}}{{obj.basisArchivePersonalData.actualResidenceDistrict}}{{obj.basisArchivePersonalData.actualResidentialAddress}}</div>
                </template>
                <template slot="studentStatus" slot-scope="scope">
                    <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.studentStatus)}} {{obj.basisArchivePersonalData.school}}{{obj.basisArchivePersonalData.theGrade}}{{obj.basisArchivePersonalData.theClass}} {{obj.basisArchivePersonalData.studentNo}}</div>
                </template>
                <template slot="obtainEmploymentStatus" slot-scope="scope">
                    <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.employmentStatus)}} {{obj.basisArchivePersonalData.employmentUnit}}</div>
                </template>
                <template slot="orderKinshipList" slot-scope="scope">
                    <div class="t-content">
                        <avue-crud :data="obj.orderKinshipList" :option="kinshipOption"></avue-crud>
                    </div>
                </template>
                <template slot="basisArchiveInterviewList" slot-scope="scope">
                    <div class="t-content">
                        <avue-crud :data="obj.basisArchiveInterviewList" :option="recordOption"></avue-crud>
                    </div>
                </template>
                <template slot="orderRelationList" slot-scope="scope">
                    <div class="t-content">
                        <avue-crud :data="obj.orderRelationList" :option="relationOption"></avue-crud>
                    </div>
                </template>
                <template slot="isServiceSituation" slot-scope="scope">
                    <div class="t-content">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.isServiceSituation)}} {{obj.basisArchivePersonalData.serviceSituationRemarks}}</div>
                    </div>
                </template>
                <template slot="serviceSituationRecord" slot-scope="scope">
                    <div class="t-content">
                        <div class="t-content">{{getValues(scope.dic,obj.basisArchivePersonalData.serviceSituationRecord)}} {{obj.basisArchivePersonalData.serviceSituationNow}}</div>
                    </div>
                </template>
                <template slot="needTo" slot-scope="scope">
                    <div class="t-content">{{getValues(scope.dic,obj.needTo)}} {{obj.needToRemark}}</div>
                </template>
                <template slot="criticalFactors" slot-scope="scope">
                    <div class="t-content">{{getValues(scope.dic,obj.criticalFactors)}} {{obj.criticalFactorsRemark}}</div>
                </template>
                <template slot="emergencyService" slot-scope="scope">
                    <div class="t-content">{{getValues(scope.dic,obj.emergencyService)}} {{obj.emergencyServiceRemark}}</div>
                </template>
                <!--  <template slot="individualCase" slot-scope="scope">
                    <div class="t-content">{{getValues(scope.dic,obj.dossier.individualCase)}} {{obj.dossier.individualCaseRemarks}}</div>
                </template> -->
                <template slot="dd">
                    <div class="two-line">
                        <div class="line df">
                            <div class="t-label">督导签字</div>
                            <div class="t-content">{{obj.supervisionSignature}}</div>
                        </div>
                        <div class="line df">
                            <div class="t-label">批阅日期</div>
                            <div class="t-content">{{obj.supervisionDay}}</div>
                        </div>
                    </div>
                </template>
            </avue-form>
        </div>
        <el-dialog title="档案详情" append-to-body width="80%" :visible.sync="orderDetailVisible">
            <pdf :info="obj" @close="orderDetailVisible = false"></pdf>
        </el-dialog>
    </basic-container>
</template>
<script>
import pdf from './components/jcda-pdf.vue'
import { getArchivesDetail, getArchivesDetailByOrderId } from '@/api/archives/index'
import { dateFormat } from "@/util/date"
export default {
    components: {
        pdf
    },
    data() {
        return {
            id: '',
            obj: {},
            option: {
                detail: true,
                labelWidth: 80,
                labelPosition: 'left',
                column: [{
                        label: '姓名',
                        prop: 'name',
                        bind: "basisArchivePersonalData.name",
                        span: 6,
                    },
                    {
                        label: "性别",
                        prop: "gender",
                        bind: 'basisArchivePersonalData.gender',
                        formslot: true,
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'sex'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 6
                    },
                    {
                        label: '出生年月',
                        prop: 'birthday',
                        bind: 'basisArchivePersonalData.birthday',
                        span: 6
                    },
                    {
                        label: '爱好',
                        prop: 'hobby',
                        bind: 'basisArchivePersonalData.hobby',
                        span: 6
                    },
                    {
                        label: '籍贯',
                        prop: 'nativePlace',
                        bind: 'basisArchivePersonalData.nativePlace',
                        span: 6
                    },
                    {
                        label: "身份证号",
                        prop: "cardNo",
                        bind: 'basisArchivePersonalData.cardNo',
                        span: 6
                    },
                    {
                        label: '电话',
                        prop: 'contact',
                        bind: 'basisArchivePersonalData.contact',
                        span: 6
                    },
                    {
                        label: '健康情况',
                        prop: 'healthyState',
                        bind: 'basisArchivePersonalData.healthyState',
                        span: 6,
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'healthy'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        }
                    },
                    {
                        label: '户籍地址',
                        prop: 'residenceAddress',
                        bind: 'basisArchivePersonalData.residenceAddress',
                        formslot: true,
                        span: 24,
                        row: true
                    },
                    {
                        label: '现住地址',
                        prop: 'actualResidentialAddress',
                        bind: 'basisArchivePersonalData.actualResidentialAddress',
                        span: 24,
                        formslot: true,
                        row: true
                    },
                    {
                        label: '就学情况',
                        prop: 'studentStatus',
                        bind: 'basisArchivePersonalData.studentStatus',
                        slot: true,
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Academic_status'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 24,
                        row: true
                    },
                    {
                        label: '学习经历',
                        prop: 'studyExperience',
                        bind: 'basisArchivePersonalData.studyExperience',
                        span: 24,
                        row: true
                    },
                    {
                        label: '家庭照料情况',
                        prop: "employmentStatus",
                        bind: 'basisArchivePersonalData.employmentStatus',
                        type: "select",
                        dataType: "number",
                        dicData: [{
                            label: '是否无人照顾',
                            value: 0
                        }, {
                            label: '是否他人照顾',
                            value: 1
                        }],
                        slot: true,
                        span: 24,
                        row: true
                    },
                    {
                        label: '类型',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Five-youth_types'
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        dataType: 'number',
                        prop: "teenagersType",
                        bind: 'basisArchivePersonalData.teenagersType',
                        span: 24,
                        row: true
                    },
                    {
                        label: '跟踪走访记录',
                        prop: 'basisArchiveInterviewList',
                        span: 24,
                        formslot: true,
                        row: true
                    },
                    {
                        label: '综合特质',
                        prop: 'comprehensive',
                        bind: 'basisArchivePersonalData.comprehensive',
                        span: 24,
                        row: true
                    },
                    {
                        label: '身高',
                        prop: "height",
                        bind: 'basisArchivePersonalData.height',
                        span: 8,
                    },
                    {
                        label: '体重',
                        prop: "weight",
                        bind: 'basisArchivePersonalData.weight',
                        span: 8,
                    },
                    {
                        label: '性格',
                        prop: "byCharacter",
                        bind: 'basisArchivePersonalData.byCharacter',
                        span: 8,
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'character'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    },
                    {
                        label: '家庭类型',
                        prop: 'householdType',
                        bind: 'basisArchivePersonalData.householdType',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'household_type'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8,
                    },
                    {
                        label: '家庭教养',
                        prop: 'familyUpbringing',
                        bind: 'basisArchivePersonalData.familyUpbringing',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'parenting_pattern'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8,
                    },
                    {
                        label: '家庭经济',
                        prop: 'familyEconomy',
                        bind: 'basisArchivePersonalData.familyEconomy',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Family-economic_status'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8,

                    }, {
                        label: '家庭经济备注',
                        prop: 'familyNote',
                        bind: 'basisArchivePersonalData.familyNote',
                        span: 24,
                        row: true
                    }, {
                        label: '不良嗜好',
                        prop: 'badAddiction',
                        bind: 'basisArchiveProblem.badAddiction',
                        type: "checkbox",
                        dicUrl: '/api/blade-system/dict-biz/dictionary',
                        dicQuery: {
                            code: 'bad_hobby'
                        },
                        dataType: "number",
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },

                    }, {
                        label: "是否有纹身",
                        prop: "tattoo",
                        bind: 'basisArchiveProblem.tattoo',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'there_tattoo'
                        },
                        dataType: "number",
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有手淫行为",
                        prop: "isMasturbation",
                        bind: 'basisArchiveProblem.isMasturbation',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dataType: "number",
                        dicQuery: {
                            code: 'Masturbation'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有观看淫秽视频行为",
                        prop: "isVideo",
                        bind: 'basisArchiveProblem.isVideo',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Obscene_video'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有打架经历",
                        prop: "fightExperience",
                        bind: 'basisArchiveProblem.fightExperience',
                        type: "checkbox",
                        dataType: "number",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Fighting_experience'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否经常出入娱乐场所",
                        prop: "entertainmentVenues",
                        bind: 'basisArchiveProblem.entertainmentVenues',
                        type: "checkbox",
                        dataType: "number",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Entertainment_place'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否夜不归宿行为",
                        dataType: "number",
                        prop: "nightOut",
                        bind: 'basisArchiveProblem.nightOut',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Nocturnal_behavior'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "作息时间",
                        prop: "workTime",
                        dataType: "number",
                        bind: 'basisArchiveProblem.workTime',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Time_Table'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有犯罪前科",
                        dataType: "number",
                        prop: "criminalRecord",
                        bind: 'basisArchiveProblem.criminalRecord',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Criminal_record'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否喜欢网络游戏",
                        dataType: "number",
                        prop: "isOnlineGame",
                        bind: 'basisArchiveProblem.isOnlineGame',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'network_game'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "在校处分情况",
                        dataType: "number",
                        prop: "isDisciplinary",
                        bind: 'basisArchiveProblem.isDisciplinary',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'punishment'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有旷课行为",
                        dataType: "number",
                        prop: "isTruancy",
                        bind: 'basisArchiveProblem.isTruancy',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Absenteeism'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "法律法规认知程度",
                        dataType: "number",
                        prop: "isRegulations",
                        bind: 'basisArchiveProblem.isRegulations',
                        type: "checkbox",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Awareness-laws_regulations'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 24,
                        row: true
                    },
                    {
                        label: '曾使用相关服务记录',
                        prop: 'isServiceSituation',
                        slot: true,
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'yes_no'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 24,
                        row: true
                    },
                    {
                        label: '现使用相关服务记录',
                        prop: 'serviceSituationRecord',
                        slot: true,
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'yes_no'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 24,
                        row: true
                    },
                    {
                        label: '亲属关系',
                        prop: 'orderKinshipList',
                        span: 24,
                        formslot: true,
                        row: true
                    },
                    {
                        label: '人际关系',
                        prop: 'orderRelationList',
                        span: 24,
                        formslot: true,
                        row: true
                    },
                    // {
                    //     label: '问题需求',
                    //     prop: 'question',
                    //     span: 24,
                    //     row: true
                    // },
                    {
                        label: '主动需求/问题摘要',
                        prop: 'problemSummary',
                        bind: 'basisArchiveProblem.problemSummary',
                        span: 24,
                        row: true
                    },
                    {
                        label: '需求跟进',
                        prop: 'needTo',
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'yes_no'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 24,
                        row: true,
                        formslot: true
                    },
                    {
                        label: '当事人是否愿意接收服务',
                        prop: 'isWilling',
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'yes_no'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 12
                    },
                    {
                        labelWidth: 0,
                        prop: 'tb',
                        span: 12,
                        formslot: true
                    },
                    {
                        label: '个案去要跟进',
                        prop: 'isFollowUp',
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'yes_no'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 12
                    },
                    {
                        label: '个案',
                        prop: 'source',
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'individual_case'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        formslot: true,
                        span: 12
                    },
                    {
                        label: '督导备注',
                        prop: 'supervisionRemark',
                        span: 12
                    },
                    {
                        labelWidth: 0,
                        prop: 'dd',
                        span: 12,
                        formslot: true
                    },
                ]
            },
            kinshipOption: {
                addBtn: false,
                menu: false,
                refreshBtn: false,
                columnBtn: false,
                showHeader: false,
                menuBtn: false,
                column: [{
                    width: 150,
                    prop: 'name'
                }, {
                    width: 155,
                    prop: 'cardId'
                }, {
                    width: 40,
                    prop: 'age'
                }, {
                    width: 50,
                    prop: 'relation'
                }, {
                    width: 110,
                    prop: 'phone'
                }, {
                    width: 100,
                    prop: 'income'
                }, {
                    width: 100,
                    prop: 'standard'
                }]
            },
            recordOption: {
                addBtn: false,
                menu: false,
                refreshBtn: false,
                columnBtn: false,
                menuBtn: false,
                column: [{
                    label: '走访类型',
                    prop: 'interviewType',
                    type: "select",
                    dicUrl: "/api/blade-system/dict-biz/dictionary",
                    dicQuery: {
                        code: 'visit-tracking_method'
                    },
                    props: {
                        label: "dictValue",
                        value: "dictKey"
                    },
                    formatter: (row, value, label, column) => {
                        return label
                    }
                }, , {
                    label: '访问时间',
                    prop: 'visitTime'
                }, {
                    label: '走访机构',
                    prop: 'createDeptName'
                }, {
                    label: '记录人',
                    prop: 'createUserName'
                },{
                    label: '内容',
                    prop: 'content'
                }]
            },
            relationOption: {
                addBtn: false,
                menu: false,
                refreshBtn: false,
                columnBtn: false,
                showHeader: false,
                menuBtn: false,
                column: [{
                    width: 150,
                    prop: 'name'
                }, {
                    width: 155,
                    prop: 'cardId'
                }, {
                    width: 110,
                    prop: 'phone'
                }, {
                    width: 50,
                    prop: 'relation'
                }, {
                    width: 40,
                    prop: 'age'
                }]
            },
            orderDetailVisible: false
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        getArchivesDetailByOrderId(this.id).then(res => {
            this.obj = res.data.data
        })

    },
    computed: {
        getValues() {
            return function(list, type) {
                let obj = list.find(v => v.dictKey == type);
                return obj ? obj.dictValue : ""
            }
        },
        getDateFormate() {
            return function(date) {
                return dateFormat(new Date(date), "yyyy-MM-dd")
            }
        }
    },
    methods: {
        goBackHandle() {
            this.$router.$avueRouter.closeTag()
            this.$router.go(-1)
        }
    }
};

</script>
<style lang="scss">
@import "@/styles/moudles/pdf.scss";

</style>
